export default [
    {
        path: '/sin-permiso',
        name: 'sin.permiso',
        component: () => import('../../pages/sinPermiso/sinPermiso').then(m => m.default || m),
    },
]